import {NotificationUsersConfirmationValidationSchema, UserSmall} from '@/features/users/types'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {Flexbox} from '../flexbox/FlexBox'
import {ConfirmationDialogAccordionContainer} from './ConfirmationDialogAccordionContainer'
import {UsersMultiSelectPopover} from '@/features/users/components/users-multi-select-popover/UsersMultiSelectPopover'
import {Button} from '../button/Button'
import {PlusIcon, XCloseIcon} from '../icon/Icon'
import {Badge} from '../badge/Badge'
import {Avatar} from '../avatar/Avatar'
import {Text} from '../text/Text'
import {TextArea} from '@/components/commons/textarea/TextArea'

export const ConfirmationDialogAccordionNotification = () => {
    const {t} = useTranslation()
    const form = useFormContext<NotificationUsersConfirmationValidationSchema>()
    const selectedUsers = useWatch({control: form.control, name: 'notificationsRecipients'})

    return (
        <Flexbox direction="column" gap={4} fullWidth>
            <ConfirmationDialogAccordionContainer gap={2} align="center">
                <UsersMultiSelectPopover
                    modal
                    selectedUserIds={selectedUsers ? selectedUsers.map(user => user.id) : []}
                    toggleClick={(user: UserSmall) => {
                        const selectedUserIds = selectedUsers?.map(u => u.id) || []
                        if (selectedUserIds.includes(user.id)) {
                            // Remove user
                            form.setValue('notificationsRecipients', selectedUsers?.filter(u => u.id !== user.id) || [])
                        } else {
                            // Add user (with only the required fields for the schema)
                            const simplifiedUser = {
                                id: user.id,
                                fullName: user.fullName
                            }
                            form.setValue(
                                'notificationsRecipients',
                                selectedUsers ? [...selectedUsers, simplifiedUser] : [simplifiedUser]
                            )
                        }
                    }}
                    trigger={
                        <Button variant="primaryNeutral" shape="square" size="sm">
                            <PlusIcon />
                        </Button>
                    }
                />

                {selectedUsers && selectedUsers.length > 0 ? (
                    selectedUsers.map(user => (
                        <Badge size="sm" shape="rectangle" key={user.id}>
                            <Avatar size="sm" name={user.fullName} />
                            {user.fullName}
                            <Button
                                shape="text"
                                variant="ghost"
                                onClick={() => {
                                    form.setValue(
                                        'notificationsRecipients',
                                        selectedUsers.filter(u => u.id != user.id)
                                    )
                                }}
                            >
                                <XCloseIcon />
                            </Button>
                        </Badge>
                    ))
                ) : (
                    <Text size="textSm" palette="neutral" shade="700">
                        {t('commons:select_consultants')}
                    </Text>
                )}
            </ConfirmationDialogAccordionContainer>
            <TextArea placeholder={t('users:notes_placeholder')} {...form.register('notificationDetails')} />
        </Flexbox>
    )
}
